<template>
  <div class="newsletter__container">
    <h4 class="newsletter-heading">
      Subscribe to receive the latest news and offers directly in your inboxes
    </h4>
    <form
      class="form newsletter-form"
      :action="`//bandwagon.us2.list-manage.com/subscribe?id=${countryNewsletterId}`"
      method="post"
      name="mc-embedded-subscribe-form"
      novalidate=""
      target="_blank"
    >
      <input
        type="hidden"
        name="u"
        value="68be48aa72ec273269d26fa70"
      >
      <input
        type="email"
        class="form__control"
        name="MERGE0"
        value=""
        :placeholder="emailText"
      >

      <input
        class="button button--primary"
        type="submit"
        :value="subscribeText"
      >
    </form>
  </div>
</template>

<script>

export default {
  name: 'NewsletterForm',

  props: {
    countryNewsletterId: {
      type: String,
      default: 'c04c8e2b7e',
    },
    locale: {
      type: String,
      default: 'en',
    },
  },

  computed: {
    emailText() { return (this.locale === 'en' ? 'Email address' : '输入电邮地址'); },
    subscribeText() { return (this.locale === 'en' ? 'Subscribe' : '订阅'); },
  },
};
</script>
